(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Listens to the 'go_to_sv_intent' message, so other plugins can trigger share (suggestions).
     *
     * Displays the sapo button on the GUI too.
     *
     * @namespace sv_go_to
     */

    /**
     * @module Messages
     *
     * This message allows other plugins to request going to SAPO Vídeos.
     *
     * @function go_to_sv_intent
     * @param {String}  messageKind='go_to_sv_intent'
     * @param {String}  from='logo'                    if logo and option trackUrl is defined, it is used. if from='author' goes to author page, else goes to SV video page
     */

    var _ = SAPO.Project.Video._;

    var plugin = function(vc, ui) {
        this._vc = vc;
        this._ui = ui;

        if (this._vc.getOption('skipBranding')) { return; }


        this._vc.subscribe('button_activated metadata_changed go_to_sv_intent', undefined, this);

        this.btnEl = this._ui.addButton('go-to-sv', 'right');
        if (this.btnEl) {
            this.btnEl.setAttribute('rel', 'external');
            this.btnEl.title = _('goToSVTitle');
            this._ui.hideButton('sv-share');
        }

    };

    plugin.prototype = {

        _name: plugin._name = 'sv_go_to',

        on_button_activated: function(mt, id) {
            if (id === 'go-to-sv') {
               this.on_go_to_sv_intent('go_to_sv_intent', 'logo');
            }
        },

        on_metadata_changed: function(mt, md) {
            if (md && !md.isAd) {
                this._pageURI   = md.link;
                this._authorURI = md.authorURI;
                this._ui.showButton('sv-share');
            }
            else {
                this._pageURI   = undefined;
                this._authorURI = undefined;
                this._ui.hideButton('go-to-sv');
            }
        },

        on_go_to_sv_intent: function(mt, from) {
            var uri = (from === 'author') ? this._authorURI : this._pageURI;
            //console.log('from:', from, 'url:', uri);

            if (uri) {
                window.open(uri, this._vc._inInternoMode ? '_top' : '_blank');
            }
        }
    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
